import { highlight } from "@/util";
import { Project } from "@/api/project";

export type SimilarProjectsProps = {
  project: Project;
  similar: Project[];
  onSelect?: (project: Project) => void;
};

export function SimilarProjects({ project, similar, onSelect }: SimilarProjectsProps) {
  return (
    <small>
      <table className={`table table-fixed table-bordered table-sm mt-2 ${onSelect && "table-hover"}`}>
        <thead className="table-light">
          <tr>
            <th>Name</th>
            <th>Number</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {similar.map((match) => (
            <tr key={match.id} className={onSelect ? "cursor-pointer" : ""} onClick={() => onSelect?.(match)}>
              <td>{highlight(match.name, project.name)}</td>
              <td>{highlight(match.number, project.number)}</td>
              <td>{highlight(match.description, project.description)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </small>
  );
}
